import { CanActivateFn, Router } from '@angular/router';
import { AuthHelper } from '../helpers/auth.helper';
import { inject } from '@angular/core';
export const authGuard: CanActivateFn = (_route, _state) => {
  if (!inject(AuthHelper).isUserLogged()) {
    inject(Router).navigateByUrl('/home');

    return false;
  }

  return true;
};
